import {ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import {ActivatedRouteSnapshot, Params, RouterStateSnapshot} from '@angular/router';
import { Injectable } from "@angular/core";
import { AnamneseState } from 'libs/anamnese/src/lib/store/anamnese.reducer';
import { AuthState } from 'libs/auth/src/lib/store/auth.reducer';
import { CustomerState } from 'libs/customer/src/lib/store/customer.reducer';
import { PatientState } from 'libs/patients/src/lib/store/patient.reducer';
import { FeatureFlagsState } from 'libs/feature-flags/src/lib/store/feature-flags.state';
import { MaintenanceState } from 'libs/maintenance/src/lib/store/maintenance.state';
import { WebviewerModificationState } from 'libs/web-viewer/src/lib/store/webviewer-modification.store';
import { RedirectState } from '../redirect-state/redirect.state';
import { redirectReducer } from '../redirect-state/redirect.reducer';

export interface RouterStateUrl {
	url: string;
	params: Params;
	queryParams: Params;
}

export interface AppState {
	anamnese?: AnamneseState;
	auth?: AuthState;
	customer?: CustomerState;
	patient?: PatientState;
	featureFlags?: FeatureFlagsState;
	webviewerModification?: WebviewerModificationState;
	maintenance?: MaintenanceState;
	router: fromRouter.RouterReducerState<RouterStateUrl>;
	routerRedirect?: RedirectState;
}

export const reducers: ActionReducerMap<AppState> = {
	router: fromRouter.routerReducer,
	routerRedirect: redirectReducer
};

export const selectRouterState = createFeatureSelector<
	fromRouter.RouterReducerState<RouterStateUrl>
	>('router');

@Injectable({
	providedIn: 'root'
})
export class CustomSerializer
	implements fromRouter.RouterStateSerializer<RouterStateUrl> {

	serialize(routerState: RouterStateSnapshot): RouterStateUrl {

		const { url } = routerState;
	    const { queryParams } = routerState.root;

		let state: ActivatedRouteSnapshot = routerState.root;
		while (state.firstChild) {
			state = state.firstChild;
		}
		const { params } = state;

		return { url, params, queryParams };
	}

}
